import { render, staticRenderFns } from "./actMaleRecords.vue?vue&type=template&id=4bfd369f&scoped=true"
import script from "./actMaleRecords.vue?vue&type=script&lang=js"
export * from "./actMaleRecords.vue?vue&type=script&lang=js"
import style0 from "./actMaleRecords.vue?vue&type=style&index=0&id=4bfd369f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd369f",
  null
  
)

export default component.exports